import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Routers from "./routers.js";
// import { wxShare } from "../utils/wxShare";

class App extends Component {
  // componentDidMount() {
  //   let url = typeof window !== "undefined" && window.location.href;
  //   wxShare.wxShare({
  //     type: 1,
  //     title: `【澎湃填字】敢来挑战你的知识储备吗？`,
  //     desc: "", // 分享描述
  //     link: `${url}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  //     imgUrl: `https://game${__APISUFFIX__}.thepaper.cn/crossword/share_img@2x.png`, // 分享图标
  //   });
  // }
  render() {
    return (
      <Switch>
        {Routers.map((item, index) => {
          return <Route {...item} key={index} />;
        })}
        {/* <Redirect
          from="/*"
          to="https://m-test.thepaper.cn/wap/resource/htmlstatic/errPage.html?code=404"
          // path="https://m-test.thepaper.cn/wap/resource/htmlstatic/errPage.html?code=404"
        /> */}
      </Switch>
    );
  }
}
export default App;
